<template>
  <b-modal
    :id="modalId"
    centered
    size="xl"
    title="Novo Cliente"
    hide-footer
    body-class="p-0 novo-cliente-modal-body"
    @show="prepararNovoClienteModal"
    @hidden="resetNovoClienteModal"
  >
    <PessoaForm
      url="/pessoa/create"
      :pessoa="novaPessoa"
      :hide-tipo-pessoa="true"
      :force-cliente="true"
      :redirect-on-save="false"
      @saved="handleNovoClienteSaved"
      @cancel="$bvModal.hide(modalId)"
    />
  </b-modal>
</template>

<script>
import PessoaForm from "@/modules/Pessoa/pages/Form.vue";
import PessoaData from "@/modules/Pessoa/pages/PessoaData";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-novo-cliente-modal",
  components: {
    PessoaForm,
  },
  mixins: [SistemaMixin],
  props: {
    modalId: {
      type: String,
      required: true,
    },
    documentoInicial: {
      type: String,
      default: "",
    },
    successMessage: {
      type: String,
      default: "Cliente cadastrado e selecionado!",
    },
    unresolvedMessage: {
      type: String,
      default:
        "Cliente cadastrado, mas não foi possível selecioná-lo automaticamente.",
    },
  },
  data() {
    return {
      novaPessoa: new PessoaData({}),
    };
  },
  methods: {
    prepararNovoClienteModal() {
      this.novaPessoa = new PessoaData({ cnpj_cpf: this.documentoInicial });
    },
    resetNovoClienteModal() {
      this.novaPessoa = new PessoaData({});
    },
    async handleNovoClienteSaved({ response, form }) {
      try {
        const cliente = await this.resolveClienteCriado(response);

        if (!cliente?.id_pessoa) {
          this.$toast.warning(this.unresolvedMessage);
          this.$bvModal.hide(this.modalId);
          this.$emit("saved", { response, form, cliente: null });
          return;
        }

        const clienteNormalizado = this.normalizeClienteCriado(cliente, form);

        this.$bvModal.hide(this.modalId);
        this.$emit("selected", clienteNormalizado);
        this.$emit("saved", { response, form, cliente: clienteNormalizado });
        this.$toast.success(this.successMessage);
      } catch {
        this.$toast.error(
          "Cliente cadastrado, mas houve erro ao selecioná-lo."
        );
      }
    },
    async resolveClienteCriado(response) {
      const responseData = response?.data ?? response;
      const cliente =
        responseData?.pessoa ??
        responseData?.cliente ??
        responseData?.data ??
        responseData;
      if (!cliente?.id_pessoa) return null;
      if (cliente.nome && cliente.cnpj_cpf) return cliente;
      try {
        const clienteCompleto = await this.findClienteById(cliente.id_pessoa);
        return Number(clienteCompleto?.id_pessoa) === Number(cliente.id_pessoa)
          ? clienteCompleto
          : cliente;
      } catch {
        return cliente;
      }
    },
    async findClienteById(id_pessoa) {
      const { data } = await this.$http.post("/pessoa/find", {
        id_pessoa,
      });

      return data?.pessoa ?? data?.data ?? data;
    },
    getEnderecosCliente(cliente) {
      if (!cliente) return [];

      if (Array.isArray(cliente.enderecos) && cliente.enderecos.length > 0) {
        return cliente.enderecos;
      }

      if (Array.isArray(cliente.endereco) && cliente.endereco.length > 0) {
        return cliente.endereco;
      }

      if (cliente.endereco && !Array.isArray(cliente.endereco)) {
        return [cliente.endereco];
      }

      return [];
    },
    normalizeClienteCriado(cliente, form) {
      const enderecos = this.getEnderecosCliente(cliente);
      const enderecosForm = this.getEnderecosCliente(form);
      const enderecosNormalizados =
        enderecos.length > 0 ? enderecos : enderecosForm;

      return {
        ...cliente,
        nome: cliente.nome || form?.nome || "",
        cnpj_cpf: cliente.cnpj_cpf || form?.cnpj_cpf || "",
        enderecos: enderecosNormalizados,
        endereco: enderecosNormalizados[0] || null,
      };
    },
  },
};
</script>
